import apiClient from './api'

export interface TenantProfile {
  tenantId: string
  workspaceName: string
  workspaceSlug: string
  companyName: string
  legalName?: string | null
  taxId?: string | null
  vatId?: string | null
  registrationNumber?: string | null
  website?: string | null
  email?: string | null
  billingEmail?: string | null
  phone?: string | null
  address?: string | null
  city?: string | null
  country?: string | null
  countryCode?: string | null
  postalCode?: string | null
  bankName?: string | null
  bankIban?: string | null
  invoicePaymentTerms?: string | null
  efacturaEnabled: boolean
  efacturaManualUploadOnly: boolean
  logoUrl?: string | null
  planCode: string
  billingStatus: string
  trialEndsAt?: string | null
  isSuspended: boolean
  createdAt: Date
  updatedAt: Date
}

export interface TenantMember {
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  role: string
  isActive: boolean
  isPlatformAdmin: boolean
  lastLogin?: string | null
  createdAt: Date
  updatedAt: Date
}

export interface TenantInvitation {
  id: string
  tenantId: string
  email: string
  role: string
  status: string
  inviteUrl?: string | null
  invitedByName?: string | null
  expiresAt: string
  acceptedAt?: string | null
  createdAt: Date
  updatedAt: Date
}

export interface UpdateTenantProfileRequest {
  workspaceName?: string
  companyName?: string
  legalName?: string
  taxId?: string
  vatId?: string
  registrationNumber?: string
  website?: string
  email?: string
  billingEmail?: string
  phone?: string
  address?: string
  city?: string
  country?: string
  countryCode?: string
  postalCode?: string
  bankName?: string
  bankIban?: string
  invoicePaymentTerms?: string
  efacturaEnabled?: boolean
  efacturaManualUploadOnly?: boolean
  logoUrl?: string
}

export interface CreateTenantInvitationRequest {
  email: string
  role?: string
  expiresInDays?: number
}

export interface TenantProfileResponse {
  data: {
    profile: TenantProfile
  }
  meta: {
    timestamp: string
  }
}

export interface TenantMembersResponse {
  data: {
    members: TenantMember[]
  }
  meta: {
    count: number
    timestamp: string
  }
}

export interface TenantInvitationsResponse {
  data: {
    invitations: TenantInvitation[]
  }
  meta: {
    count: number
    timestamp: string
  }
}

export interface TenantInvitationResponse {
  data: {
    invitation: TenantInvitation
  }
  meta: {
    timestamp: string
  }
}

export const tenantService = {
  getProfile: () => apiClient.get<TenantProfileResponse>('/tenant/profile').then((response) => response.data),

  updateProfile: (data: UpdateTenantProfileRequest) =>
    apiClient.put<TenantProfileResponse>('/tenant/profile', data).then((response) => response.data),

  getMembers: () => apiClient.get<TenantMembersResponse>('/tenant/members').then((response) => response.data),

  getInvitations: () =>
    apiClient.get<TenantInvitationsResponse>('/tenant/invitations').then((response) => response.data),

  createInvitation: (data: CreateTenantInvitationRequest) =>
    apiClient.post<TenantInvitationResponse>('/tenant/invitations', data).then((response) => response.data),

  cancelInvitation: (id: string) => apiClient.delete(`/tenant/invitations/${id}`),
}
